import React, { SetStateAction, useState } from 'react';
import { makeStyles, Theme, createStyles, Typography, Grid, FormHelperText, Button } from '@material-ui/core';
import { Link } from 'react-router-dom';
import CheckboxGroup from '../../../components/ui/inputs/checkbox';
import File from '../../../components/ui/inputs/file';
import { useForm } from 'react-hook-form';
import handleError from '../../../utils/handleError';
import ordersRepository from 'client-sdk/src/Repository/orders-repository';
import Icon from '@mdi/react';
import { mdiExclamation } from '@mdi/js';
import Modal from '../../../components/Modal';
import { Response3PL } from '../../orders/components/response3Pl';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        paper: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: '100%',
            paddingTop: theme.spacing(3),
            paddingBottom: theme.spacing(3),
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
            border: '1px solid #D8D8D8',
            boxShadow: '0px 1px 12px 4px rgba(0, 0, 0, 0.04)',
            borderRadius: '10px',
            backgroundColor: "#fff",
        },
        headerBox: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: '28px',
            position: 'fixed',
            top: '0',
            right: '0',
            width: '100%',
            padding: '20px 68px 20px 90px',
            backgroundColor: "#fff",
            boxShadow: "0px 1px 12px 4px rgba(0, 0, 0, 0.04)",
            zIndex: 12
        },
        errorIcon: {
            border: "1px solid #ff2400",
            borderRadius: "50px",
            marginRight: "10px"
        },
        error: {
            border: "3px solid #ff2400"
        }
    }),
);

interface Inputs {
    orderType: string;
    origin: string;
    destination: string;
    file: null | string;
}

const options = [
    { label: "تعارف", value: 1, img: "/TAROFF_V2.png", id: 18 },
    { label: "لینک اکسپرس", value: 2, img: "/LINK_EXPRESS.png", id: 2 },
    { label: "الو پیک", value: 3, img: "/ALOPEYK.png", id: 3 },
    { label: "چاپار", value: 4, img: "/CHAPAR.png", id: 4 },
    { label: "پتروکس", value: 5, img: "/PETROEX.png", id: 5 },
    { label: "پیشرو پست", value: 6, img: "/PISHRO_POST.png", id: 6 },
    { label: "دی تی اس", value: 7, img: "/DTSXP.png", id: 7 },
    { label: "اسپید", value: 8, img: "/SPEED.png", id: 8 },
    { label: "تاپین پست", value: 9, img: "/TAPIN_POST.png", id: 9 },
    { label: "تاپین کتاب", value: 10, img: "/TAPIN_KETAB.png", id: 10 },
]

const SubmitFile = (props: any) => {
    const classes = useStyles();
    const {
        register,
        errors,
        handleSubmit,
        setValue,
    } = useForm<Inputs>({
        defaultValues: {
            orderType: '',
            file: null,
        },
    });
    const [file, setFile] = useState<any>();
    const [loading, setLoading] = useState(false as boolean);
    const [error, setError] = useState(false as boolean);
    const [openResponse3PL, setOpenResponse3PL] = useState(false as boolean);
    const [orderResults3PL, setOrderResults3PL] = useState([]);

    const select = (list: SetStateAction<string[]>) => {
        props.select(list)
        if (list.length == 0) {
            setError(true)
        } else {
            setError(false)
        }
    }

    const suggest3PL = async () => {
        if (props.selected.length == 0) {
            setError(true)
            return
        }
        try {
            setLoading(true);
            let payload = new FormData();
            if (file) {
                payload.append('file', file);
            }
            const response = await ordersRepository.getSuggestedCourierAssignmentList({
                payload: {
                    body: payload,
                    params: { activeTplIds: props.selected.join(",") }
                }
            })
            props.setData(response.data)
            props.setState("SUGGESTED")
        } catch (err) {
            handleError(err.response);
        } finally {
            setFile(null);
            setValue('file', null);
            setLoading(false);
        }
    };

    const manual3PL = async () => {
        // if (props.selected.length == 0) {
        //     setError(true)
        //     return
        // }
        try {
            setLoading(true);
            let payload = new FormData();
            if (file) {
                payload.append('file', file);
            }
            // const response = await ordersRepository.validateOrdersBeforeCreateTpl({
            //     payload: {
            //         body: payload,
            //     }
            // })
            const response = await ordersRepository.upload3PL({ payload: { body: payload } })
            setOpenResponse3PL(true);
            setOrderResults3PL(response.data)
            // handleNotfication('سفارشات با موفقیت ایجاد شدند', 'success');
            // props.setData(response.data)
            // props.setState("MANUAL")

        } catch (err) {
            handleError(err.response);
        } finally {
            setFile(null);
            setValue('file', null);
            setLoading(false);
        }
    }

    const handleChangeFileInput = (event: any) => {
        setFile(event.target.files[0]);
    };

    const modalCloseHandler = () => {
        setOpenResponse3PL(false);
    };
    return (
        <>
            <div className={classes.headerBox}>
                <Typography variant="h5" component="h2">
                    ثبت دسته‌جمعی 3PL
                </Typography>
            </div>
            <Grid
                container
                direction="row"
                justify="space-between"
                alignItems="center"
                style={{ marginTop: "50px" }}
            >
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    {error && <>
                        <Icon path={mdiExclamation} size={1} color={"#ff2400"} className={classes.errorIcon} />
                        <h3 className='text-error'>لطفا 3pl های فعال را انتخاب کنید !</h3>
                    </>}
                </div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Link
                        to="/tPLInstruction.xlsx"
                        style={{
                            color: '#000',
                            marginLeft: '15px',
                        }}
                        target="_blank"
                    >
                        {'دانلود فایل راهنما'}
                    </Link>
                    <Link
                        to="/sample3PL.xlsx"
                        style={{
                            color: '#000',
                        }}
                        target="_blank"
                    >
                        {'دانلود فایل نمونه'}
                    </Link>
                </div>
            </Grid>
            <form onSubmit={handleSubmit(manual3PL)} style={{ width: '100%' }}>
                <Grid container style={{ margin: '10px 0' }} alignItems="flex-start">
                    <Grid
                        style={{ padding: '10px 0' }}
                        container
                        spacing={3}
                        alignItems="stretch"
                    >
                        <Grid
                            container
                            item
                            justify="center"
                            xs={12}
                            sm={12}
                            md={2}
                            lg={2}
                        >
                            <div
                                // elevation={3}
                                className={error ? classes.paper + " " + classes.error : classes.paper}
                            // variant="elevation"
                            // square
                            >
                                <h2>انتخاب 3pl های فعال</h2>
                                <hr style={{ width: "100%", color: "#DADADA" }} />
                                <CheckboxGroup selected={props?.selected} select={select} options={options} />
                            </div>
                        </Grid>
                        <Grid
                            container
                            item
                            justify="center"
                            xs={12}
                            sm={12}
                            md={10}
                            lg={10}
                        >
                            <div
                                // elevation={3}
                                className={classes.paper}
                            // variant="elevation"
                            // square
                            >
                                <File handleChangeFileInput={handleChangeFileInput} ref={register({ required: true })} file={file} />
                                <FormHelperText error focused>
                                    {errors.file && ' فایل الزامی میباشد'}
                                </FormHelperText>
                            </div>
                        </Grid>
                    </Grid>
                    <Grid container item xs={12} alignItems="flex-start">
                        <Grid item container justify="flex-end" xs={12}>
                            <Button
                                type="submit"
                                disabled={loading}
                                size="large"
                                data-cy="search"
                                variant="contained"
                                color="primary"
                                style={{ marginLeft: "10px" }}
                            >
                                ثبت دستی
                            </Button>
                            <Button
                                onClick={suggest3PL}
                                disabled={loading}
                                size="large"
                                data-cy="search"
                                variant="contained"
                                color="primary"
                            >
                                پیشنهاد 3pl
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </form>
            <Modal
                maxWidth="lg"
                fullScreen
                onClose={modalCloseHandler}
                open={openResponse3PL}
                title={
                    <div>
                        <h3 style={{ padding: "0 20px" }}>
                            {"ارسال درخواست "}
                        </h3>
                    </div>
                }
                content={<Response3PL data={orderResults3PL} />}
            />
        </>
    )
}

export default SubmitFile;
